// Copyright (c) 2022 by Move Closer

import { mapModel } from '@movecloser/front-core'

import {
  AllowedAttributes,
  AttributeValue,
  ProductData,
  ProductSneakPeakData
} from '../../../../contexts'

import { attributesAdapterMap } from '../../models/attributes.adapter'

import { ProductCardProps, ProductCardVariant } from './ProductCard.contracts'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const isAttribute = (value: AttributeValue | AttributeValue[]): value is (AttributeValue | AttributeValue[]) => {
  if (typeof value === 'string' && value.length === 0) {
    return false
  }

  return Object.values<AttributeValue | AttributeValue[]>(AllowedAttributes).includes(value)
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const translateProductToProductCard = (product: ProductData | ProductSneakPeakData, useAdapted: boolean = true, sortByPrice: boolean = true): ProductCardProps => {
  /**
   * Sorts variants by promotion price
   */
  function byPromotion (variantOne: ProductCardVariant, variantTwo: ProductCardVariant): number {
    const promoOne = (variantOne.price.regularPrice - variantOne.price.finalPrice) / variantOne.price.regularPrice
    const promoTwo = (variantTwo.price.regularPrice - variantTwo.price.finalPrice) / variantTwo.price.regularPrice

    if (!!promoOne && !!promoTwo) {
      if (promoOne === promoTwo) { // if both are on equal sale, pick cheaper
        return variantOne.price.finalPrice - variantTwo.price.finalPrice
      }

      // if both are on sale, pick higher sale
      return promoTwo - promoOne
    }

    if (promoOne) { // if first is on sale, pick one
      return -1
    }

    if (promoTwo) { // if second is on sale, pick two
      return 1
    }

    // if none is on sale, pick cheaper
    return variantOne.price.finalPrice - variantTwo.price.finalPrice
  }

  /**
   * Sorts variants by promotion price
   */
  function byPrice (variantOne: ProductCardVariant, variantTwo: ProductCardVariant): number {
    if (!sortByPrice) {
      return 0
    }

    return variantOne.price.finalPrice - variantTwo.price.finalPrice
  }

  /**
   * Sorts variants by availability
   */
  function byAvailablility (variantOne: ProductCardVariant, variantTwo: ProductCardVariant): number {
    if (variantOne.sellableQuantity < 1) {
      return 1
    }

    if (variantTwo.sellableQuantity < 1) {
      return -1
    }

    return 0
  }

  const variants = Object.values(product.variants!).filter(item => {
    return item && 'images' in item
  }).map<ProductCardVariant>((variant) => {
    return {
      ...variant,
      attributes: useAdapted ? mapModel(variant.attributes, attributesAdapterMap, false) : variant.attributes
    }
  })
    .sort(byPromotion)
    .sort(byPrice)
    .sort(byAvailablility)

  // if (variants.length > 1) {
  //   console.info(variants.map(v =>
  //     `[price: ${v.price.finalPrice} (${v.price.regularPrice}), promo: ${(v.price.regularPrice - v.price.finalPrice) / v.price.regularPrice}, q: ${v.sellableQuantity}]`
  //   ).join('\n'))
  // }

  return {
    ...product,
    variants
  }
}
